/**
 * @generated SignedSource<<bf82c12d0a128ebb3b02a7c92ab121f0>>
 * @relayHash 2e87e44ccd23b96b693c0a7aa5925e74
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e87e44ccd23b96b693c0a7aa5925e74

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type DayOfWeek = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type WorkingType = "CLOSED" | "HOURLY" | "OPEN24_HOURS";
export type useCareProviderWithOriginQuery$variables = {
  id: string;
  language: string;
  skip?: boolean | null;
};
export type useCareProviderWithOriginQuery$data = {
  readonly ch_careProviderByRelationalId?: {
    readonly additionalAddress: string | null;
    readonly billsVia: {
      readonly businessName: string | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly title: string | null;
    } | null;
    readonly businessName: string | null;
    readonly careProviderGroup: {
      readonly groupType: CareProviderGroupType;
    };
    readonly careProviderSearchHistories: ReadonlyArray<{
      readonly createdAt: string;
      readonly " $fragmentSpreads": FragmentRefs<"historyEventsTableFragment">;
    }>;
    readonly careProviderSpecialtyTranslations: ReadonlyArray<{
      readonly name: string;
    }>;
    readonly city: string | null;
    readonly country: {
      readonly countryName: string | null;
    } | null;
    readonly countryCode: string | null;
    readonly creditorCodeRegister: string | null;
    readonly detailedSchedule: ReadonlyArray<{
      readonly day: DayOfWeek;
      readonly periods: ReadonlyArray<{
        readonly end: string;
        readonly start: string;
      }> | null;
      readonly workingType: WorkingType;
    }> | null;
    readonly email: string | null;
    readonly firstName: string | null;
    readonly globalLocationNumber: number | null;
    readonly groupName: string | null;
    readonly id: string;
    readonly insuranceCareProviderListIds: ReadonlyArray<string> | null;
    readonly isActive: boolean | null;
    readonly isMedgatePartnerNetworkMember: boolean | null;
    readonly isTakesNewPatients: boolean | null;
    readonly lastChange: {
      readonly changedAt: string;
      readonly changedBy: string | null;
    } | null;
    readonly lastName: string | null;
    readonly network: {
      readonly name: string;
    } | null;
    readonly officialLanguageLookupTranslations: ReadonlyArray<{
      readonly isoLanguageName: string;
    }>;
    readonly phoneNumber: string | null;
    readonly postalCode: string | null;
    readonly relationBusinessName: string | null;
    readonly relationFirstName: string | null;
    readonly relationLastName: string | null;
    readonly relationTitle: string | null;
    readonly relationType: string | null;
    readonly streetAddress: string | null;
    readonly title: string | null;
    readonly website: string | null;
  } | null;
  readonly ch_careProviderOrigin?: {
    readonly email: string | null;
    readonly phoneNumber: string | null;
    readonly website: string | null;
  } | null;
};
export type useCareProviderWithOriginQuery = {
  response: useCareProviderWithOriginQuery$data;
  variables: useCareProviderWithOriginQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v8 = {
  "alias": null,
  "args": (v7/*:: as any*/),
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  (v9/*:: as any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoLanguageName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": (v7/*:: as any*/),
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditorCodeRegister",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgatePartnerNetworkMember",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insuranceCareProviderListIds",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTakesNewPatients",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalLocationNumber",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalAddress",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "LastChange",
  "kind": "LinkedField",
  "name": "lastChange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "changedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "changedBy",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationBusinessName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationFirstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationLastName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationTitle",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "DaySchedule",
  "kind": "LinkedField",
  "name": "detailedSchedule",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimePeriod",
      "kind": "LinkedField",
      "name": "periods",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "careProviderRelationId",
      "variableName": "id"
    }
  ],
  "concreteType": "CareProviderOverlayOutput",
  "kind": "LinkedField",
  "name": "ch_careProviderOrigin",
  "plural": false,
  "selections": [
    (v19/*:: as any*/),
    (v20/*:: as any*/),
    (v21/*:: as any*/)
  ],
  "storageKey": null
},
v37 = [
  (v9/*:: as any*/),
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCareProviderWithOriginQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "CareProvider",
            "kind": "LinkedField",
            "name": "ch_careProviderByRelationalId",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": (v7/*:: as any*/),
                "concreteType": "SpecialtyTranslation",
                "kind": "LinkedField",
                "name": "careProviderSpecialtyTranslations",
                "plural": true,
                "selections": (v10/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*:: as any*/),
                "concreteType": "OfficialLanguageLookupTranslation",
                "kind": "LinkedField",
                "name": "officialLanguageLookupTranslations",
                "plural": true,
                "selections": [
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroup",
                "plural": false,
                "selections": [
                  (v12/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              },
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": (v10/*:: as any*/),
                "storageKey": null
              },
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              (v29/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderHistoryEntry",
                "kind": "LinkedField",
                "name": "careProviderSearchHistories",
                "plural": true,
                "selections": [
                  (v30/*:: as any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "historyEventsTableFragment"
                  }
                ],
                "storageKey": null
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/),
              (v33/*:: as any*/),
              (v34/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "billsVia",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v35/*:: as any*/)
            ],
            "storageKey": null
          },
          (v36/*:: as any*/)
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCareProviderWithOriginQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "CareProvider",
            "kind": "LinkedField",
            "name": "ch_careProviderByRelationalId",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": (v7/*:: as any*/),
                "concreteType": "SpecialtyTranslation",
                "kind": "LinkedField",
                "name": "careProviderSpecialtyTranslations",
                "plural": true,
                "selections": (v37/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*:: as any*/),
                "concreteType": "OfficialLanguageLookupTranslation",
                "kind": "LinkedField",
                "name": "officialLanguageLookupTranslations",
                "plural": true,
                "selections": [
                  (v11/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroup",
                "plural": false,
                "selections": [
                  (v12/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v13/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": (v37/*:: as any*/),
                "storageKey": null
              },
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              (v29/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderHistoryEntry",
                "kind": "LinkedField",
                "name": "careProviderSearchHistories",
                "plural": true,
                "selections": [
                  (v30/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jsonPayload",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/),
              (v33/*:: as any*/),
              (v34/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "billsVia",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v4/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v35/*:: as any*/)
            ],
            "storageKey": null
          },
          (v36/*:: as any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2e87e44ccd23b96b693c0a7aa5925e74",
    "metadata": {},
    "name": "useCareProviderWithOriginQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d30841fa626715aba0e20e5df806190e";

export default node;
